module.exports = __webpack_public_path__ + "img/btn3.bba1eb7.png";